import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './modules/auth'
import ui from './modules/ui'
import dialog from './modules/dialog'
import estates from './modules/estates'
import ethereum from './modules/ethereum'
import wallet from './modules/wallet'

// Vuex Plugins
import createAPIPlugin, { 
	MAKE_REQUEST,
	MAKE_POST_REQUEST,
	MAKE_PUT_REQUEST
} from './plugins/api'

Vue.use (Vuex)

const apiPlugin = createAPIPlugin ()

export default new Vuex.Store ({
	modules: {
		auth,
		ui,
		dialog,
		estates,
		ethereum,
		wallet
	},
	mutations: {
		[MAKE_REQUEST] () {},
		[MAKE_POST_REQUEST] () {},
		[MAKE_PUT_REQUEST] () {}
	},
	getters: {
		re20IntrinsicValue: ({ ethereum }, { estatesTotalValue }) => {
			return estatesTotalValue / ethereum.circulatingSupplyNum
		},
		re721IntrinsicValue: (state, { estatesTotalValue, circulatingSupply }) => {
			return estatesTotalValue / circulatingSupply
		},
		loadingSystemVariables: ({ ethereum, estates }) => ethereum.loading || estates.loading,
		userEstates: ({ auth, estates, wallet }) => {
			if (!auth.user || !wallet.defaultAccount) { return }
			return estates.estates.filter (estate => estate.owner.toLowerCase () == wallet.defaultAccount.toLowerCase ())
		}
	},
	plugins: [apiPlugin]
})